export const enum ExpiryStatus {
  Invalid = 1,
  InvalidIfStale,
  Valid,
}
